<template>
  <TruePanel class="p-3 mb-2 data-card">
    <div class="flex w-full">
      <div class="label text-blue text-bold">
        {{ label }}
      </div>
      <div class="flex-grow text-right text-bold">
        <span v-if="type === 'boolean'"> {{ value === true ? 'Yes' : 'No' }} </span>
        <span v-else> {{ value ? new Intl.NumberFormat('en-US').format(value) : 0 }} </span>
      </div>
      <div class="ml-2">
        <button type="button" @click="toggleEditor">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- EDITOR -->
    <div class="editor" v-if="editorOpen">
      <NumberInput :value="value" controls @change="handleChange" v-if="type === 'number'"/>

      <template v-if="type === 'boolean'">
          <div class="flex">
            <button type="button" class="button small outline mr-2" :class="{'bg-blue': value === true}" @click="booleanClick(true)">Yes</button>
            <button type="button" class="button small outline" @click="booleanClick(false)">No</button>
          </div>
      </template>  
      <!-- <button class="btn" @click="closeEditor">Save</button> -->
    </div>
  </TruePanel>
</template>

<script>
import TruePanel from './TruePanel.vue'
import NumberInput from './NumberInput.vue'

export default {
  components: {
    TruePanel,
    NumberInput
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    type: {
      type: String,
      default: 'number'
    }
  },

  data: () => ({
    editorOpen: false,
  }),

  methods: {
    toggleEditor() {
      this.editorOpen = !this.editorOpen
    },

    openEditor() {
      this.editorOpen = true
    },

    closeEditor() {
      this.editorOpen = false
    },

    handleChange(newValue) {
      this.$emit('input', newValue)
    },

    booleanClick(value) {
      this.closeEditor()
      this.handleChange(value)
    }
  },

}
</script>

<style scoped>
.data-card {
  min-height: 65px;
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
}

.fa-pencil {
  color: #838383;
}

.editor {
  padding-top: 1rem;
}

button {
  cursor: pointer;
  background: transparent;
  border: none;
}
</style>
